<template>
	<div class="main-container">
		<img class="logo" src="../assets/LensAdvisors_cropped.svg" @click="toMain()" />
		<div class="product-container">
			<AdComponent
				style="margin-bottom: 70px;"
				v-if="sharedState.adInfo.approved && windowWidth > 1200"
				v-bind="sharedState.adInfo"
				:imageUrl="sharedState.adInfo.image"
			/>
			<div class="product-description">
				<h1>{{sharedState.selectedProduct ? sharedState.selectedProduct.name : null}}</h1>
				<h2>{{sharedState.selectedProduct ? sharedState.selectedProduct.extra_description : null}}</h2>
			</div>
			<img v-bind:src="sharedState.selectedProduct ? sharedState.selectedProduct.detail_image : null" alt />
		</div>
		<AdComponent
			style="margin-bottom: 70px"
			v-if="sharedState.adInfo.approved && windowWidth <= 1200"
			v-bind="sharedState.adInfo"
			:imageUrl="sharedState.adInfo.image"
		/>
		<div class="right-container">
			<div class="comparison-container">
				<div class="tab-container">Price Comparisons</div>
                <div v-if="sharedState.loading">
                    <div v-for="i in 4 " :key="i" class="supplier">
                        <v-skeleton-loader style="border: 1px solid #EFEFEF;" type="actions,list-item"></v-skeleton-loader>
                    </div>
                </div>
                <div v-if="!sharedState.loading">
                    <div v-for="supplierPrice in sharedState.supplierPrices " :key="supplierPrice.id" class="supplier">
                        <SupplierPrice v-bind:supplierPrice="supplierPrice"></SupplierPrice>
                    </div>
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import SupplierPrice from "../components/SupplierPriceComponent";
import store from '../services/product/store';
import AdComponent from "@/components/AdComponent";

export default {
	name: "ComparePage",
	metaInfo() {
		return {
			title: `Compare ${this.sharedState.selectedProduct.name} prices - LensAdvisors`,
			meta: [
				{ vmid: 'description', name: 'description', content: `Compare ${this.sharedState.selectedProduct.name} prices among the leading contact lens suppliers` },
				{
					vmid: "og:title",
					property: "og:title",
					content: `Compare ${this.sharedState.selectedProduct.name} prices among the leading contact lens suppliers - LensAdvisors`
				},
				{
					vmid: "og:description",
					property: "og:description",
					content:
						`Compare ${this.sharedState.selectedProduct.name} prices among the leading contact lens suppliers`
				},
				{
					vmid: "og:image",
					property: "og:image",
					content: `https://www.lensadvisors.com${require('@/assets/LensAdvisors.jpg')}`
				},
				{
					property: "og:image:width",
					content: "1060",
					vmid: "og:image:width"
				},
				{
					property: "og:image:height",
					content: "203",
					vmid: "og:image:height"
				},
				{
					vmid: "og:site_name",
					property: "og:site_name",
					content: "LensAdvisors"
				}
			]
		}
	},
	data: () => {
		return {
			sharedState: store.state,
			windowWidth: window.innerWidth
		};
	},
	components: {
		SupplierPrice,
		AdComponent
	},
	methods: {
		toMain() {
			this.$router.go(-1);
		},
		onResize() {
			this.windowWidth = window.innerWidth;
		}
	},
	created() {
		store.getProductPrices(this.$route.params.id);
		if (!this.sharedState.selectedProduct)
			store.getProduct(this.$route.params.id);

		if (!this.sharedState.adInfo.clientName) {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((position) => {
					store.setLatitude(position.coords.latitude);
					store.setLongitude(position.coords.longitude);
					store.getSpot(position.coords.latitude, position.coords.longitude);
				});
			}
		}
	},
	mounted() {
		window.addEventListener('resize', this.onResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	}
};
</script>

<style lang="scss" scoped>
	.logo {
		position: absolute;
		top: 20px;
		left: 20px;
		cursor: pointer;
	}

	.main-container {
		display: flex;
		margin: 0 auto;
		margin-top: 120px;
        justify-content: space-evenly;
		align-content: center;
		padding: 5%;

		.product-container {
			// align-self: center;
			flex: 4;
            max-width: 475px;

			.product-description {
				text-align: center;
				margin-bottom: 20px;

				h1 {
					color: #18125a;
					font-size: 2rem;
				}

				h2 {
					font-size: 1.5rem;
					color: #18125a;
					font-weight: normal;
				}
			}

			img {
				width: calc(100% - 2px);
			}
		}

        .right-container {
            display: flex;
            flex-direction: column;

            .comparison-container {
                flex: 6;
                padding: 20px;
                position: relative;
                border: 2px solid #efefef;
                border-radius: 5px;

                .supplier {
                    padding: 10px;
                }

                .tab-container {
                    position: absolute;
                    border: 2px solid #efefef;
                    border-bottom: none;
                    border-radius: 5px 5px 0px 0px;
                    top: -50px;
                    left: -2px;
                    width: auto;
                    padding: 0px 10px;
                    height: 50px;
                    z-index: 9;
                    background: white;
                    text-align: center;
                    line-height: 50px;
                    font-size: 1rem;
                    color: grey;
                }
            }

            // .ads-container {
            //     display: flex;
            //     align-self: center;
            //     justify-content: space-between;
            //     height: 125px;
            //     width: 75%;
            //     margin-top: 25px;
            //     padding: 20px;

            //     a {
            //         margin: 0;
            //     }

            //     p {
            //         color: #707070;
            //         margin: 0;
            //     }

            //     img {
            //         width: 50px;
            //         height: 50px;
            //     }
            // }
        }

		
	}

	@media screen and (max-width: 1200px) {
		.main-container {
			flex-direction: column;

			.product-container {
				margin-bottom: 50px;
				align-self: center;

				img {
					display: none;
				}
			}
		}
	}

	@media screen and (max-width: 600px) {
		.main-container {
			width: 90%;

			// .product-container {
			//     display: none;
			// }
			// .product-description {
			//     flex-direction: column;

			//     img {
			//         width: 100%;
			//     }

			//     .product-details {
			//         h2 {
			//             font-size: 2rem;
			//         }
			//         .lens-description {
			//             display: flex;
			//             flex-direction: row;
			//             align-content: center;
			//             margin: 5px 2px;

			//             i {
			//                 font-size: 1.3rem;
			//             }

			//             p {
			//                 margin: 0;
			//                 margin-left: 5px;
			//                 font-size: 1rem;
			//                 color: #707070;
			//             }
			//         }
			//     }
			// }

            .right-container {
                .comparison-container {
                    flex-direction: column-reverse;

                    .comparison-list {
                        flex: 8;
                        .supplier-price {
                            width: 100%;
                            margin-bottom: 15px;
                        }
                    }

                    
                }

                .ads-container {
                    width: 100%;

                    img {
                        display: none;
                    }
                }
            }
			
		}
	}
</style>